import { useParams } from "react-router-dom";
import { directorsData } from "./DirectorsData";
import "./DirectorProfile.css";
import Footer from "./Footer";

export default function DirectorProfile() {
    const { slug } = useParams();
    const director = directorsData.find(d => d.slug === slug);

    if (!director) return null;

    return (
        <section id="dir-pg">
            <div className="director-page">
                <h2 className="director-title">Board Of Directors</h2>
                <div className="director-underline"></div>

                <div className="director-box">
                    <div className="director-image">
                        {director.img ? (
                            <img src={director.img} alt={director.name} />
                        ) : (
                            <div className="director-image-placeholder"></div>
                        )}
                    </div>

                    <h3 className="director-name">{director.name}</h3>
                    <p className="director-role">{director.role}</p>

                    {director.bio.map((para, i) => (
                        <p key={i} className="director-para">{para}</p>
                    ))}

                    {/* {director.directorships && director.directorships.length > 0 && (
                        <div className="director-directorships">
                            <h4 className="directorships-title">Other Directorships</h4>
                            <ul className="directorships-list">
                                {director.directorships.map((d, i) => (
                                    <li key={i}>{d}</li>
                                ))}
                            </ul>
                        </div>
                    )} */}
                </div>

            </div>
            <Footer />
        </section>
    );
}
